import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Utils from '../../scripts/Utils';

const ServiceRepository = RepositoryFactory.get('services');

// initial state
// shape: [{ id, quantity }]
const state = {
    deployments: null,
    blockedSites: null,
    deploymentTable: {
        headers: [
            {text: 'Datum', value: 'updated_at'},
            {text: 'Seite', value: 'site'},
            {text: 'Bezeichner', value: 'siteType_name'},
            {text: 'Typ', value: 'siteType_type'},
        ]
    }
};

// getters
const getters = {
    deploymentsData(state) {
        let ret = [];
        if (state.deployments) {
            state.deployments.forEach((item) => {
                ret.push(item.data);
            })
        }
        return ret;
    },
    blockedSites(state) {
        let ret = [];
        if (state.blockedSites) {
            state.blockedSites.forEach((item) => {
                item.data.initials = item.data.usermail !== 'Keine' ? Utils.getInitials(item.data.usermail) : 'N/A';
                item.data.name = Utils.getName(item.data.usermail);
                ret.push(item.data);
            })
        }
        return ret;
    }
};

// actions
const actions = {
    async fetchDashboard({commit}) {
        await ServiceRepository.getDashboard().then((res) => {
            if (typeof res !== "undefined" && res.status === 200) {
                if (state.blockedSites === null || !Utils.arraysEqual(state.blockedSites, res.data.Users)) {
                    commit('setDeployments', {data: res.data.Deployments});
                    commit('setlockedSites', {data: res.data.Users});
                }
            }
        }).catch(err => {
            console.error(err);
        });
    },
};

// mutations
const mutations = {
    setDeployments(state, {data}) {
        state.deployments = data;
    },
    setlockedSites(state, {data}) {
        state.blockedSites = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}